import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

export function getReports(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getReports${q}`, {
    headers: {
      authorization: token,
    },
  });
}

// Lists Tab
export function getLists(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getLists${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getListsDownloadExport(query, options) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getViewReport${q}`, options);
}
export function getViewListsDownload(query, options) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getViewListDetails${q}`, options);
}

// End //
export function getAllColumns(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getAllColumnsList${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getReportsByReportName(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getViewReport${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function getReportsByListName(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getViewListDetails${q}`, {
    headers: {
      authorization: token,
    },
  });
}
export function getreportsDownloadExport(query, options) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getViewReport${q}`, options);
}


export function getReportsExportExcelData(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getViewReport${q}`, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
}
export function getSubsidiaryOption(token,query) {
  const q = buildQuery(query); 
  return axios.get(`${baseUrl}/getSubsidiary${q}`, {
    headers: {
      authorization: token,
    },
  });
}
